/* eslint-disable no-underscore-dangle */
import React from "react";
// import { Type } from "../Transaction/helper";
// import { TaxType } from "../../components/Select/Tax/enum";
import { t } from "@lingui/macro";
import { Big, Float } from "bukku/redux/Transaction/calculation/helper";
import { parsePhoneNumber } from "libphonenumber-js";

export const Helper = {
    parseItemTax: (itemTax, taxCodes, originalDocumentType, taxMode, amountAfterDiscountB) => {
        const {
            ID: taxID,
            Percent: taxPercent,
            TaxAmount: taxAmount,
            TaxableAmount: taxableAmount,
            TaxableAmountExempted: taxableAmountExempted,
            TaxExemptionReason: taxExemptionReason,
        } = itemTax;

        let taxCode, type;

        switch (taxID) {
            case '01': { // Sales tax. ref: https://sdk.myinvois.hasil.gov.my/codes/tax-types/
                type = "sales_tax";
                // if ([Type.sale_invoice, Type.sale_credit_note].includes(originalDocumentType))
                //     taxType = TaxType.sales_invoice;
                // else
                //     taxType = TaxType.purchase;
                // taxCode = taxCodes.find(t => t.tax_system === "mysst_sales_tax" && t.rate === taxPercent && t.type === taxType);
                taxCode = t`Sales Tax (${taxPercent}%)`;
                break;
            }
            case '02': { // Service tax
                type = parseInt(taxPercent, 10) === 6 ? "service_tax_6" : "service_tax_8";
                // if ([Type.sale_invoice, Type.sale_credit_note].includes(originalDocumentType))
                //     taxType = TaxType.sales_payment;
                // else
                //     taxType = TaxType.purchase;
                // taxCode = taxCodes.find(t => t.tax_system === "mysst_service_tax" && t.rate === taxPercent && t.type === taxType);
                taxCode = t`Service Tax (${taxPercent}%)`;
                break;
            }
            case 'E': { // Tax exempted
                // const icon = (
                //     <BukkuTooltip title={taxExemptionReason}>
                //         <QuestionCircleOutlined />
                //     </BukkuTooltip>
                // );
                return {
                    tax_percent: taxPercent,
                    tax_code: (
                        <span>
                            {t`Tax Exempted`}
                            {/* &nbsp;
                            {icon} */}
                        </span>
                    ),
                    tax_amount: taxableAmountExempted || 0,
                    taxable_amount: taxableAmount,
                    tax_exemption_reason: taxExemptionReason,
                    type: "service_tax_exempted",
                };
            }
            case '06': // No tax selected
            default:
                return null;
        }

        let calculatedTaxAmount = taxAmount;
        // Normal transactions won't have taxAmount, only consolidated txns will.
        // So for normal txn, do the calculation of tax amount here
        if (!calculatedTaxAmount && calculatedTaxAmount !== 0) {
            if (taxMode === 'exclusive') {
                calculatedTaxAmount = Float(
                    amountAfterDiscountB.times(taxPercent).div(100).round(2),
                );
            }
            else {
                calculatedTaxAmount = Float(
                    amountAfterDiscountB.div(Big(taxPercent).plus(100)).times(taxPercent).round(2),
                );
            }
        }

        return {
            tax_percent: taxPercent,
            tax_code: taxCode,
            tax_amount: calculatedTaxAmount,
            taxable_amount: taxableAmount,
            tax_exemption_reason: taxExemptionReason,
            type,
        };
    },

    parseItemTaxes: (item, taxCodes, originalDocumentType, taxMode, amountAfterDiscountB) => {
        let itemTaxes = item.Tax;
        if (!itemTaxes)
            return [];

        if (!Array.isArray(itemTaxes))
            itemTaxes = [itemTaxes];
        return itemTaxes.map(
            tax => Helper.parseItemTax(tax, taxCodes, originalDocumentType, taxMode, amountAfterDiscountB),
        ).filter(obj => obj !== null);
    },

    parseMyInvoisDocumentItems: (payloadItems = [], taxCodes = [], originalDocument = {}, taxMode = 'exclusive') => {
        const items = payloadItems.map(item => {
            // Calculate amount, discount and amount after discount
            // const amountB = Big(item.PriceAmount).times(Big(item.InvoicedQuantity)).round(2);
            const amountB = Big(item.ItemPriceExtension).round(2); // can straight away use data from xml payload

            const hasDiscount = item.AllowanceCharges?.length;
            const discount = hasDiscount ? Big(item.AllowanceCharges[0].Amount).toFixed(2) : null; //string
            const discountAmountB = hasDiscount ? Big(item.AllowanceCharges[0].Amount).round(2) : Big(0);

            const amountAfterDiscountB = amountB.minus(discountAmountB); // 2 dp

            // Return Items
            return ({
                description: item.Description,
                classification_code: item.ItemClassificationCodes[0], // we'll always only have one product cc
                quantity: item.InvoicedQuantity,

                unit_price: item.PriceAmount,
                amount: Float(amountB),

                discount, //string
                discount_amount: Float(discountAmountB), // number

                // Tax: [
                // {ID: "01", Percent: 10, TaxAmount: 0.16, TaxableAmount: 100},
                // {ID: "E", TaxExemptionReason: "Exemption Schedule A", TaxableAmountExempted: 1 }
                // ...],
                // * Note: TaxAmount and TaxableAmount is only present in consolidated transactions.
                // But TaxExemptionReason and TaxableAmountExempted is present in both normal and consolidated transactions.
                taxes: Helper.parseItemTaxes(
                    item, taxCodes, originalDocument.type, taxMode, amountAfterDiscountB,
                ),
            });
        });

        return items;
    },

    parseBundleDiscount: allowanceCharges => {
        if (!Array.isArray(allowanceCharges))
            allowanceCharges = [allowanceCharges]; // Convert to array

        let bundleDiscountB = Big(0);
        allowanceCharges.forEach(obj => {
            bundleDiscountB = bundleDiscountB.plus(Big(obj["cbc:Amount"]?._text));
        });

        return bundleDiscountB;
    },

    getSummaryData: (items, taxMode, isRoundingOn, formItemsSummary = {}, taxTotal = "0.00", allowanceChargesArr = []) => {
        let discountB = Big(0);
        const subtotalAfterDiscountB = Big(formItemsSummary?.["cbc:LineExtensionAmount"]?._text || 0);

        // Get bundle discount from payload
        const bundleDiscountB = Helper.parseBundleDiscount(allowanceChargesArr)?.neg();

        const taxTypeMappingB = {
            sales_tax: Big(0),
            service_tax_6: Big(0),
            service_tax_6_taxable_amount: Big(0),
            service_tax_8: Big(0),
            service_tax_8_taxable_amount: Big(0),
            service_tax_exempted: Big(0),
        };

        items?.forEach(record => {
            // subtotalB = subtotalB.plus(record.amount || 0);
            discountB = discountB.minus(record.discount_amount || 0);

            record.taxes?.forEach(({type, tax_amount, taxable_amount}) => {
                if (taxTypeMappingB[type]) {
                    taxTypeMappingB[type] = taxTypeMappingB[type].plus(tax_amount || 0);

                    // console.log('aaa getSummaryData type', {type, tax_amount, taxable_amount});
                    switch (type) {
                        case 'service_tax_6':
                        case 'service_tax_8':
                            taxTypeMappingB[`${type}_taxable_amount`] = taxTypeMappingB[`${type}_taxable_amount`].plus(new Big(taxable_amount || 1));
                            break;
                        default:
                            break;
                    }

                    // if (taxMode === 'inclusive' && type !== 'service_tax_exempted') // dont minus service_tax_exempted
                    //     subtotalB = subtotalB.minus(tax_amount);
                }
            });
        });

        // Tax Total
        // const totalTaxAmtB = taxTypeMappingB.sales_tax
        //     .add(taxTypeMappingB.service_tax_6)
        //     .add(taxTypeMappingB.service_tax_8);

        // Grand Total
        // const totalBeforeRoundingB = subtotalB.plus(discountB).plus(totalTaxAmtB);

        // 5-cent rounding
        // const totalAfterRoundingB = Big(Math.ceil(totalBeforeRoundingB.times(20)
        //     .minus(0.5)))
        //     .div(20);
        // const roundingB = totalAfterRoundingB.minus(totalBeforeRoundingB);
        // const totalB = isRoundingOn ? totalAfterRoundingB : totalBeforeRoundingB;

        return {
            sales_tax: Float(taxTypeMappingB.sales_tax),
            service_tax_6: Float(taxTypeMappingB.service_tax_6),
            service_tax_8: Float(taxTypeMappingB.service_tax_8),
            service_tax_exempted: Float(taxTypeMappingB.service_tax_exempted),
            tax: Float(taxTotal),

            service_tax_6_taxable_amount: Float(taxTypeMappingB.service_tax_6_taxable_amount),
            service_tax_8_taxable_amount: Float(taxTypeMappingB.service_tax_8_taxable_amount),

            subtotal: Float(subtotalAfterDiscountB.minus(discountB).minus(bundleDiscountB)), // LineExtensionAmount is Total amount after discount. To get back before discount, add back the discount. (discounts here are negative, so use minus)
            discount: Float(discountB), // can't use formItemsSummary["cbc:AllowanceTotalAmount"]._text as it's always 0 because the value is not used in LHDN and thus it's not computed and submitted to them
            bundle_discount: Float(bundleDiscountB),
            rounding: Float(formItemsSummary?.["cbc:PayableRoundingAmount"]?._text || 0),
            total: Float(formItemsSummary?.["cbc:PayableAmount"]._text || 0),
        };
    },

    parseAccountingParty: (accountingParty, countries, countryStates) => {
        const registrationTypes = ["NRIC", "BRN", "PASSPORT"];
        const partyInfo = {};
        accountingParty["cac:PartyIdentification"].forEach(party => {
            const {schemeID} = party["cbc:ID"]._attributes;
            if (registrationTypes.includes(schemeID)) {
                partyInfo.registration = {
                    type: schemeID,
                    number: party["cbc:ID"]._text,
                };
            }
            else {
                partyInfo[party["cbc:ID"]._attributes.schemeID.toLowerCase()] = party["cbc:ID"]._text;
            }
        });
        partyInfo.legal_name = accountingParty["cac:PartyLegalEntity"]["cbc:RegistrationName"]._text;
        partyInfo.msic_code = accountingParty["cbc:IndustryClassificationCode"]?._text;
        partyInfo.msic_name = accountingParty["cbc:IndustryClassificationCode"]?._attributes.name;
        let contactPhone;
        try {
            contactPhone = parsePhoneNumber(accountingParty["cac:Contact"]["cbc:Telephone"]?._text).formatInternational();
        }
        catch (e) {
            contactPhone = accountingParty["cac:Contact"]["cbc:Telephone"]?._text;
        }
        partyInfo.phone = contactPhone;
        console.log('aaa Helper parseAccountingParty', {accountingParty, partyInfo});
        // .formatInternational();
        partyInfo.email = accountingParty["cac:Contact"]["cbc:ElectronicMail"]?._text;

        const postalAddress = accountingParty["cac:PostalAddress"];
        const countrySubentityCode = postalAddress["cbc:CountrySubentityCode"]?._text;
        const countryInfo = postalAddress["cac:Country"];

        let countryIdentificationCode;
        if (countryInfo) {
            if (Array.isArray(countryInfo))
                countryIdentificationCode = countryInfo[0]["cbc:IdentificationCode"]?._text;
            else
                countryIdentificationCode = countryInfo["cbc:IdentificationCode"]?._text;
        }

        let addressLine;
        if (postalAddress["cac:AddressLine"]) {
            if (Array.isArray(postalAddress["cac:AddressLine"]))
                addressLine = postalAddress["cac:AddressLine"][0]["cbc:Line"]._text;
            else
                addressLine = postalAddress["cac:AddressLine"]["cbc:Line"]?._text;
        }

        const cityName = postalAddress["cbc:CityName"]?._text || "";
        const postalZone = postalAddress["cbc:PostalZone"]?._text || "";

        partyInfo.address = `${addressLine}
${cityName}`;

        console.log('aaa Helper parseAccountingParty', {postalAddress, countrySubentityCode, countryIdentificationCode, countryStates});
        let postalAndStateName = "";
        if (countrySubentityCode) {
            const stateName = countryStates.find(state => state.code === countrySubentityCode)?.name;

            if (postalZone && stateName)
                postalAndStateName = `${postalZone}, ${stateName}`;
            else if (postalZone)
                postalAndStateName = `${postalZone || ''}`;
            else if (stateName)
                postalAndStateName = `${stateName || ''}`;
            else
                postalAndStateName = null;

            partyInfo.address += postalAndStateName ? `\n${postalAndStateName}` : "";
        }
        if (countryIdentificationCode) {
            const countryName = countries
                .find(country => country.a3_code === countryIdentificationCode)?.name;
            if (countryName)
                partyInfo.address += `\n${countryName}`;
        }
        // partyInfo.address += ".";
        return partyInfo;
    },

    parseInvoiceLines: invoiceLines => {
        if (!Array.isArray(invoiceLines))
            invoiceLines = [invoiceLines]; // Convert to array

        const parsedInvoiceLines = [];
        invoiceLines?.forEach(line => {
            const invoiceLine = {};
            invoiceLine.PriceAmount = line["cac:Price"]["cbc:PriceAmount"]._text;
            invoiceLine.InvoicedQuantity = line["cbc:InvoicedQuantity"]._text;

            // Discount given
            invoiceLine.AllowanceCharges = [{
                Amount: line["cac:AllowanceCharge"]?.["cbc:Amount"]._text,
            }];
            invoiceLine.Description = line["cac:Item"]["cbc:Description"]._text;
            invoiceLine.ItemClassificationCodes = [line["cac:Item"]["cac:CommodityClassification"]["cbc:ItemClassificationCode"]._text];

            // Total amount before discount, before tax
            invoiceLine.ItemPriceExtension = line["cac:ItemPriceExtension"]["cbc:Amount"]._text;

            // Total amount after discount (unused)
            // invoiceLine.LineExtensionAmount = line["cbc:LineExtensionAmount"]._text;

            let taxSubtotalToUse = line["cac:TaxTotal"]["cac:TaxSubtotal"];
            if (!Array.isArray(taxSubtotalToUse))
                taxSubtotalToUse = [taxSubtotalToUse];

            const taxArr = [];
            taxSubtotalToUse.forEach(taxSubtotal => {
                const tax = {};
                tax.ID = taxSubtotal["cac:TaxCategory"]["cbc:ID"]._text;
                tax.Percent = taxSubtotal["cbc:Percent"]._text;

                tax.TaxAmount = taxSubtotal["cbc:TaxAmount"]._text;

                tax.TaxableAmount = taxSubtotal["cbc:TaxableAmount"]._text;
                tax.TaxableAmountExempted = taxSubtotal["cac:TaxCategory"]["cbc:ID"]._text === "E" ? taxSubtotal["cbc:TaxableAmount"]._text : "0";
                tax.TaxExemptionReason = taxSubtotal["cac:TaxCategory"]["cbc:TaxExemptionReason"]?._text;
                taxArr.push(tax);
            });
            invoiceLine.Tax = taxArr;

            parsedInvoiceLines.push(invoiceLine);
        });

        return parsedInvoiceLines;
    },

    parseBillingReferences: refs => {
        if (!refs)
            return [];
        if (!Array.isArray(refs))
            refs = [refs]; // Convert to array

        const parsedBillingReferences = [];
        refs.forEach(ref => {
            const billingReference = {};
            billingReference.ID = ref["cac:InvoiceDocumentReference"]["cbc:ID"]._text;
            billingReference.UUID = ref["cac:InvoiceDocumentReference"]["cbc:UUID"]._text;

            parsedBillingReferences.push(billingReference);
        });

        return parsedBillingReferences;
    },

    parseAdditionalReferences: additionalReferences => {
        if (!additionalReferences)
            return [];
        if (!Array.isArray(additionalReferences))
            additionalReferences = [additionalReferences]; // Convert to array

        const parsedAdditionalReferences = [];
        additionalReferences.forEach((ref, index) => {
            const documentType = ref["cbc:DocumentType"]?._text ?? "Incoterms";
            parsedAdditionalReferences[documentType] = ref["cbc:ID"]._text;
        });

        return parsedAdditionalReferences;
    },

    parseTaxSummary: taxSummary => {
        if (!taxSummary)
            return [];

        let parsedTaxSummary = taxSummary["cac:TaxSubtotal"];

        if (!parsedTaxSummary)
            return [];

        let taxes = [];

        if (!Array.isArray(parsedTaxSummary))
            parsedTaxSummary = [parsedTaxSummary]; // Convert to array

        parsedTaxSummary.forEach(tax => {
            const newTax = {};
            const taxID = tax["cac:TaxCategory"]["cbc:ID"]._text;
            const taxAmount = tax["cbc:TaxAmount"]._text;
            const taxableAmount = tax["cbc:TaxableAmount"]._text;

            newTax.id = taxID;
            // newTax.Percent = tax["cbc:Percent"]._text;
            newTax.taxAmount = taxAmount;
            newTax.taxableAmount = taxableAmount;

            let key, taxCode;
            switch (taxID) {
                case '01': { // Sales tax. ref: https://sdk.myinvois.hasil.gov.my/codes/tax-types/
                    // type = "sales_tax";
                    // if ([Type.sale_invoice, Type.sale_credit_note].includes(originalDocumentType))
                    //     taxType = TaxType.sales_invoice;
                    // else
                    //     taxType = TaxType.purchase;
                    // taxCode = taxCodes.find(t => t.tax_system === "mysst_sales_tax" && t.rate === taxPercent && t.type === taxType);
                    // taxCode = t`Sales Tax (${taxPercent}%)`;
                    key = 'sales_tax';
                    taxCode = t`Sales Tax`;
                    break;
                }
                case '02': { // Service tax
                    // type = parseInt(taxPercent, 10) === 6 ? "service_tax_6" : "service_tax_8";
                    // if ([Type.sale_invoice, Type.sale_credit_note].includes(originalDocumentType))
                    //     taxType = TaxType.sales_payment;
                    // else
                    //     taxType = TaxType.purchase;
                    // taxCode = taxCodes.find(t => t.tax_system === "mysst_service_tax" && t.rate === taxPercent && t.type === taxType);
                    key = 'service_tax';
                    taxCode = t`Service Tax`;
                    break;
                }
                case 'E': { // Tax exempted
                    // const icon = (
                    //     <BukkuTooltip title={taxExemptionReason}>
                    //         <QuestionCircleOutlined />
                    //     </BukkuTooltip>
                    // );
                    // return {
                    //     tax_code: (
                    //         <span>
                    //             {t`Tax Exempted`}
                    //             {/* &nbsp;
                    //             {icon} */}
                    //         </span>
                    //     ),
                    //     tax_amount: taxableAmountExempted || 0,
                    //     type: "service_tax_exempted",
                    // };
                    key = 'service_tax_exempted';
                    taxCode = t`Tax Exempted`;
                    break;
                }
                case '06': // No tax selected
                default:
                    break;
            }

            newTax.key = key;
            newTax.taxCode = taxCode;

            taxes.push(newTax);
        });

        taxes = taxes.filter(tax => tax.id !== '06');

        return taxes;
    },
};
